import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const RestoreFromTrashIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue938'}</MuiIcon>
    );
}
